const companyValidator = {
	name: {
		rules: [
			{
				test: /^[a-z0-9A-Z_\sА-Яа-яҐЄІЇїіє]+$/,
				message: 'Please enter valid name',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	email: {
		rules: [
			{
				test: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
				message: 'Please enter valid email',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	types: {
		rules: [
			{
				test: (values) => {
					let res = true;
					if(Array.isArray(values)) {
						values.forEach(type => {
							if(!/^[a-z0-9A-Z_]+$/.test(type)) {
								res = false;
							}
						})
					}
					return res;
				},
				message: 'Please select valid type',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	countryCode: {
		rules: [
			{
				test: /^[a-z0-9A-Z_\sА-Яа-яҐЄІЇїіє]+$/,
				message: 'Please select valid country',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	cityGeonameId: {
		rules: [
			{
				test: /^[a-z0-9A-Z_\s-\sА-Яа-яҐЄІЇїіє]+$/,
				message: 'Please select valid city',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	languageId: {
		rules: [
			{
				test: /^[0-9]+$/,
				message: 'Please select valid language',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	manager: {
		rules: [
			{
				test: /^[a-z0-9A-Z_\sА-Яа-яҐЄІЇїіє]+$/,
				message: 'Please enter valid manager name',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	phone: {
		rules: [
			{
				test: /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g,
				message: 'Please enter valid phone',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	skype: {
		rules: [
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Please enter valid skype login',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	status: {
		rules: [
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Please select valid status',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	newUserDefaultPassword: {
		rules: [
			{
				test: (value) => {
					return value.length >= 6;
				},
				message: 'Password can not be < 6 characters',
			},
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Enter Valid Password',
			},
		],
		errors: [],
		valid: false,
		state: ''
	}
};

export default companyValidator;



// WEBPACK FOOTER //
// ./src/helpers/companyValidator.js